import IngkaSSRIcon, { SSRIconProps } from '@ingka/ssr-icon';
import React from 'react';

const SSRIcon = (props: SSRIconProps) => (
    <IngkaSSRIcon prefix="list-ingka-" {...props} />
);

export default SSRIcon;
